<template>
  <div class="record">
    <!-- <h1>历史记录</h1> -->
    <!-- <el-table :data="historyData" :stripe="true" :border="true" height="500">
      <el-table-column prop="lastTableNumber" label="上次表号" width="90"></el-table-column>
      <el-table-column prop="currentTableNumber" label="当前表号" width="90"></el-table-column>
      <el-table-column prop="money" label="电费" width="90"></el-table-column>
      <el-table-column prop="numberOfWords" label="字数" width="90"></el-table-column>
      <el-table-column prop="unitPrice" label="单价" width="50"></el-table-column>
      <el-table-column prop="date" label="日期" width="100"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row.id)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table> -->

    <!-- 可展开列表 -->

    <el-table :data="historyData" style="width: 100%" max-height="550">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="电费：">
              <span>{{ props.row.money }}</span>
            </el-form-item>
            <el-form-item label="字数：">
              <span>{{ props.row.numberOfWords }}</span>
            </el-form-item>
            <el-form-item label="上次表号：">
              <span>{{ props.row.lastTableNumber }}</span>
            </el-form-item>
            <el-form-item label="当前表号：">
              <span>{{ props.row.currentTableNumber }}</span>
            </el-form-item>
            <el-form-item label="单价：">
              <span>{{ props.row.unitPrice }}</span>
            </el-form-item>
            <el-form-item label="日期：">
              <span>{{ props.row.date }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="电费">
        <template slot-scope="scope">
          <!-- <el-tag type="info" class="bold">{{ scope.row.money }}</el-tag> -->
          <span class="bold">{{ scope.row.money }}</span>
        </template>
      </el-table-column>
      <el-table-column label="日期">
        <template slot-scope="scope">
          <el-tag type="warning" class="bold">{{ scope.row.date }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popconfirm
            title="确定删除吗？"
            @confirm="handleClick(scope.row.id)"
            ><el-button type="danger" size="small" slot="reference"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getHistory, deleteRecord } from "@/api/api";
import { dataMap } from "@/utils";
export default {
  data() {
    return {
      historyData: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async handleClick(id) {
      await deleteRecord(id);
      this.loadData();
    },
    async loadData(page, limit) {
      const { datas } = await getHistory(page, limit);
      dataMap(datas);
      this.historyData = datas;
      console.log(datas);
    },
  },
};
</script>

<style scoped>
.demo-table-expand {
  font-size: 0;
  text-align: center;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.bold {
  text-align: center;
  font-weight: bolder;
}
</style>